document.addEventListener("DOMContentLoaded", function () {
  let lastClicked = null;

  // Tooltips stories (mobile & desktop)
  document.querySelectorAll('.animated-stories-link').forEach(function (el) {
    el.addEventListener('click', function (e) {
      const tooltip = el.querySelector('.tooltip-bubble');
      if (!tooltip) return;

      const isMobile = window.innerWidth < 768;

      if (isMobile) {
        if (lastClicked === el && tooltip.classList.contains('visible')) {
          return; // 2e clic : laisse passer le lien
        }

        e.preventDefault(); // 1er clic mobile = bloque le lien
        document.querySelectorAll('.tooltip-bubble').forEach(tip => tip.classList.remove('visible'));
        tooltip.classList.add('visible');
        lastClicked = el;

        setTimeout(() => {
          tooltip.classList.remove('visible');
          lastClicked = null;
        }, 3000);
      }
    });
  });

  document.addEventListener('click', function (e) {
    const isIcon = e.target.closest('.animated-stories-link');
    if (!isIcon) {
      document.querySelectorAll('.tooltip-bubble.visible').forEach(function (tip) {
        tip.classList.remove('visible');
      });
      lastClicked = null;
    }
  });

  // Redirection dynamique des langues
  document.querySelectorAll('.language-selector a').forEach(link => {
    const currentPath = window.location.pathname;
    const currentLang = currentPath.split('/')[1];
    const targetLang = link.getAttribute('data-lang');

    if (['fr', 'en', 'de'].includes(currentLang)) {
      const relativePath = currentPath.split('/').slice(2).join('/');
      link.href = `/${targetLang}/${relativePath}`;
    } else {
      link.href = `/${targetLang}${currentPath}`;
    }
  });

  // Init carousels SplideJS
  var carousels = document.querySelectorAll('.splide');
  carousels.forEach(function (carousel) {
    new Splide(carousel, {
      type: 'loop',
      perPage: 1,
      autoplay: true,
      interval: 5000,
      pauseOnHover: true,
      arrows: true,
      pagination: true,
    }).mount();
  });
});